// import { spy } from 'mobx';
import { ModalsContainer } from '@monorepo/controlled/src/components/modal/modals-container/modals-container';
import { ToastsContainer } from '@monorepo/controlled/src/components/toast/toasts-container/toasts-container';
import { TooltipsContainer } from '@monorepo/controlled/src/components/tooltip/tooltips-container/tooltips-container';
import { HelmetProvider } from 'react-helmet-async';
import * as Sentry from '@sentry/react';
import './app.scss';
import { Envs } from '@monorepo/tools/src/lib/enums/env';
import { useEffect } from 'react';
import packageJson from '../../package.json';
import { AdminXRouter } from '../modules/router/router';
import { ErrorsContainer } from '../modules/components/errors-container/errors-container';
import { getConfig } from '@monorepo/tools/src/lib/get-config';
import { generateStorageKey, removeOldPerssistableStores } from '@monorepo/controlled/src/stores/helper';
import { Head } from '../modules/components/head/head';
import { SearchParamsGlobalDecleration } from '@monorepo/base/src/components/link-with-params/link-with-params';
import { REQUEST_ID, SESSION_ID } from '../lib/consts/storage';
import { hash } from '@monorepo/tools/src/lib/tools/hash';
import { ask, IRequestInterceptor } from '@monorepo/tools/src/lib/tools/ask/ask';

// Mobx Event listener
// spy(event => {
// 	console.log(`TCL ~ event`, event);
// 	if (event.type === 'action') {
// 		console.log(`TCL ~ ${event.name} with args: ${event.arguments}`);
// 	}
// });

if (getConfig().env.projectEnv === Envs.Production) {
	Sentry.init({
		environment: getConfig().env.projectEnv,
		dsn: 'https://43614f611f5e4d35a69efefbbd797917@o206854.ingest.sentry.io/6616704',
	});
}
function App() {
	useEffect(() => {
		console.log('v' + packageJson.version);
		removeOldPerssistableStores();
	}, []);

	let sessionId = sessionStorage.getItem(generateStorageKey(SESSION_ID)) || '';
	if (!sessionId) {
		sessionId = hash.uuid();
		sessionStorage.setItem(generateStorageKey(SESSION_ID), sessionId);
	}

	const traceInterceptor: IRequestInterceptor = {
		call: url => {
			const queryParams = new URLSearchParams(window.location.search);
			const shuli = queryParams.get('shuli');

			if (shuli) {
				url.searchParams.set('shuli', shuli);
			}

			url.searchParams.set(REQUEST_ID, hash.uuid());
			url.searchParams.set(SESSION_ID, sessionId);
		},
	};

	ask.interceptors.requests.set('RequestTrace', traceInterceptor);

	const platform = getConfig().env.platform;
	console.log('platform', platform);
	if (platform) {
		const platformInterceptor: IRequestInterceptor = {
			call: (url, requestOptions) => {
				requestOptions.headers = {
					'x-platform': platform,
					...requestOptions.headers,
				};
			},
		};
		ask.interceptors.requests.set('Platform', platformInterceptor);
	}

	return (
		<Sentry.ErrorBoundary>
			<HelmetProvider>
				<Head />
				<ErrorsContainer />
				<ModalsContainer />
				<ToastsContainer />
				<TooltipsContainer />
				<SearchParamsGlobalDecleration knownsSearchParams={['maze']} />
				<AdminXRouter />
			</HelmetProvider>
		</Sentry.ErrorBoundary>
	);
}

export default App;
